import { Customer } from "@commercetools/platform-sdk"
import { useRootSelector } from "State"

export const useCustomerState = (): Customer | undefined => {
  return useRootSelector(it => it.customerState.customer)
}
